import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string | number

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP,
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}
